import { useLazyNcziExtensionItemQuery } from '../../../graphql/graphql';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

export default function useNCZIDefaultValues() {
	const [getExtensionItem] = useLazyNcziExtensionItemQuery();

	const extensionDefaultValue = async (input?: NCZIExtension) => {
		if (!input?.code || !input?.scheme?.oid) {
			return undefined;
		}

		let extLabel = input.code;

		const { item: extensionItem } = await getExtensionItem({
			oid: input.scheme.oid,
			code: input.code,
		}).unwrap();

		if (extensionItem) {
			extLabel += ' - ' + extensionItem.name;
		}

		return {
			value: input,
			label: extLabel,
		};
	};

	const referenceDefaultValue = (
		input?: NCZIReference,
		showCode: boolean = false,
	) => {
		if (!input?.code || !input?.scheme?.oid || !input?.scheme?.version) {
			return undefined;
		}

		return {
			value: input,
			label: (showCode ? input.code + ' - ' : '') + input?.displayName,
		};
	};

	return {
		extensionDefaultValue,
		referenceDefaultValue,
	};
}
